import { usePriceFeeds } from 'src/common/queries/usePriceFeeds/usePriceFeeds'
import { getPriceFromPriceFeed } from 'src/common/queries/usePriceFeeds/utils'
import { AnyToken } from 'src/common/types/models/Tokens'
import { big } from 'src/common/utils/big-utils'
import { calcEquivalentTargetAsset } from 'src/common/utils/offers/offerPrices'

const usePairMarketPrice = (tokenA: AnyToken, tokenB: AnyToken) => {
  const tokenAddresses = [tokenA.contractAddress, tokenB.contractAddress]
  const { priceFeeds, isLoading } = usePriceFeeds(tokenAddresses)

  const tokenAPrice = getPriceFromPriceFeed(priceFeeds, tokenA.contractAddress)
  const tokenBPrice = getPriceFromPriceFeed(priceFeeds, tokenB.contractAddress)

  const pricePerA =
    tokenAPrice && tokenBPrice
      ? calcEquivalentTargetAsset(big(1), tokenAPrice, tokenBPrice)
      : null
  const pricePerB =
    tokenAPrice && tokenBPrice
      ? calcEquivalentTargetAsset(big(1), tokenBPrice, tokenAPrice)
      : null

  return { pricePerA, pricePerB, loading: isLoading }
}

export default usePairMarketPrice
